import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

const formatMoney = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  return new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(numericValue);
};

function RelImportacaoDesativados(items = [], sheetName = "") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;

  const emittedAt = new Date();
  const emittedLabel = `${String(emittedAt.getDate()).padStart(2, "0")}/${String(
    emittedAt.getMonth() + 1,
  ).padStart(2, "0")}/${emittedAt.getFullYear()}`;

  const body = [
    [
      { text: "CODIGO", style: "tableHeader" },
      { text: "NOME", style: "tableHeader" },
      { text: "CPF", style: "tableHeader" },
      { text: "VALOR ATUAL", style: "tableHeader" },
    ],
    ...items.map((item) => [
      { text: String(item.client?.cdcli || "-"), fontSize: 9 },
      { text: item.client?.decli || "-", fontSize: 9 },
      { text: item.client?.cnpj_cpfcli || "-", fontSize: 9 },
      {
        text: formatMoney(item.client?.vlrmensal),
        fontSize: 9,
        alignment: "right",
      },
    ]),
  ];

  const docDefinition = {
    pageSize: "A4",
    pageOrientation: "landscape",
    pageMargins: [20, 70, 20, 35],
    header: {
      margin: [20, 15, 20, 0],
      stack: [
        { text: "Importacao de associados - clientes a desativar", bold: true, fontSize: 15 },
        {
          text: `Competencia/aba: ${sheetName || "-"}   Emissao: ${emittedLabel}   Registros: ${items.length}`,
          fontSize: 10,
          margin: [0, 6, 0, 0],
        },
      ],
    },
    content: [
      {
        table: {
          headerRows: 1,
          widths: [60, "*", 120, 90],
          body,
        },
        layout: "lightHorizontalLines",
      },
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
      },
    },
  };

  pdfMake.createPdf(docDefinition).open();
}

export default RelImportacaoDesativados;
